import React from 'react';
import { Grid } from '@material-ui/core';
import { observer } from 'mobx-react';
import { useDescope } from '@descope/react-sdk';

import { Banner } from 'core/components/banner';
import { Button } from 'core/components/button';
import { Label } from 'core/components/label';
import { signOut as cognitoLogout } from 'core/components/auth';
import useSession from 'core/hooks/use-session';

import useStyles from './impersonation-banner.styles';

const ImpersonationBanner = observer(() => {
  const classes = useStyles();
  const session = useSession();
  const { logout: descopeLogout } = useDescope();

  const handleEndImpersonation = async () => {
    await cognitoLogout();
    await descopeLogout();
  };

  return (
    <Banner color="orange" show={!!session.isImpersonating} iconType="alert">
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid container item xs={8} alignItems="center">
          <Label type="smallWhiteBold">
            You are impersonating {session.user?.email || 'another user'}. End the impersonation session when you're
            done.
          </Label>
        </Grid>
        <Button variant="contained" className={classes.endButton} onClick={handleEndImpersonation}>
          End Impersonation
        </Button>
      </Grid>
    </Banner>
  );
});

export default ImpersonationBanner;
